import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { MutationOptions } from '../types/MutationOptions';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { useEntityCacheInvalidation } from 'app/agriculture/mutations/useEntityCacheInvalidation';
import { useSnapshotCacheInvalidation } from 'app/agriculture/mutations/useSnapshotCacheInvalidation';

export function useHerdRemoveMutation({
    onSuccess = () => {
        /* do nothing */
    },
    onError = () => {
        /* do nothing */
    },
}: MutationOptions = {}) {
    const instance = createAxiosInstance();
    const { removeFromCache: removeHerdFromCache } = useEntityCacheInvalidation('Herd');
    const { removeSnapshotsFromCache } = useSnapshotCacheInvalidation('Herd');

    const { mutate, isPending } = useMutation({
        mutationFn: async (id: string) => {
            await instance.delete<never, AxiosResponse<never>>(`/herds/${id}/`);
            return { id };
        },
        onSuccess: ({ id }) => {
            onSuccess({ id });
            removeHerdFromCache(id);
            removeSnapshotsFromCache(id);
        },
        onError,
    });
    return { mutate, isPending };
}
